import { JwVideoArticle } from '@/components/JwVideo/Article';
import { LabradorComponent } from '@/types/component';

import { getB2BVideoInfo, getVideoOptions } from 'base/components/JwVideo/Article/utils/dataParser';

export const LabradorJwVideoArticle: LabradorComponent = ({ data, meta, type }) => {
  const videoOptions = getVideoOptions(data);
  const b2bVideoInfo = getB2BVideoInfo(data);

  const { enableDesc, fieldSettings, durationMinutes, teaserLink, metadata, playerSrc } = data;

  const titleTextSize = fieldSettings?.title?.textSize;

  const disableVideoLazyLoad = true;
  const disableTeaserLazyLoad = meta.teaserIndex <= 10;

  return (
    <JwVideoArticle
      playerSrc={playerSrc}
      videoData={videoOptions}
      b2bVideo={b2bVideoInfo}
      showDescription={enableDesc}
      durationMinutes={durationMinutes}
      videoPageLink={teaserLink}
      titleTextSize={titleTextSize}
      metadata={metadata}
      disableLazyLoad={disableVideoLazyLoad || disableTeaserLazyLoad}
      options={{
        $image: {
          priority: disableTeaserLazyLoad,
        },
        $videoContainer: {
          $thumbnail: {
            priority: disableTeaserLazyLoad,
          },
        },
      }}
    />
  );
};
